import { createBrowserRouter, Outlet } from 'react-router-dom';
import LoginPage from '../features/login/LoginPage';
import CustomersListPage from '../features/customers/list';
import GuestRoute from './GuestRoute';
import ProtectedRoute from './ProtectedRoute';
import ErrorBoundary from '../components/ErrorBoundary';
import NotFoundPage from './NotFoundPage';
import HomeRedirect from './HomeRedirect';
import CustomerCreatePage from '../features/customers/create';
import AdvisorCreatePage from '../features/advisors/create';
import AdvisorsListPage from '../features/advisors/list';
import CustomerDetailPage from '../features/customers/detail';
import AdvisorDetailPage from '../features/advisors/detail';
import RecordingsListPage from '../features/recordings/list';
import RecordingDetailPage from '../features/recordings/detail';
import UploadRecordingPage from '../features/upload_recordings';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Outlet />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        index: true,
        element: <HomeRedirect />,
      },
      {
        path: 'login',
        element: (
          <GuestRoute>
            <LoginPage />
          </GuestRoute>
        ),
      },
      {
        element: (
          <ProtectedRoute>
            <Outlet />
          </ProtectedRoute>
        ),
        children: [
          {
            path: 'customers',
            element: <CustomersListPage />,
          },
          {
            path: 'customers/new',
            element: <CustomerCreatePage />,
          },
          {
            path: 'customers/:id',
            element: <CustomerDetailPage />,
          },
          {
            path: 'advisors',
            element: <AdvisorsListPage />,
          },
          {
            path: 'advisors/new',
            element: <AdvisorCreatePage />,
          },
          {
            path: 'advisors/:id',
            element: <AdvisorDetailPage />,
          },
          {
            path: 'recordings',
            element: <RecordingsListPage />,
          },
          {
            path: 'recordings/:id',
            element: <RecordingDetailPage />,
          },
          {
            path: 'upload-recording',
            element: <UploadRecordingPage />,
          },
        ],
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
]);

export default router;
